export const getScheduleExecutionTime = ({
    startDate,
    cadence,
    dayOfMonth,
}) => {
    const now = new Date();
    const _startDate = new Date(startDate);
    let executionDate = _startDate.getTime() > now.getTime() ? _startDate : now;

    if (cadence === 'monthly') {
        executionDate.setMonth(executionDate.getMonth() + 1, dayOfMonth);
    } else if (cadence === 'weekly') {
        executionDate.setDate(
            executionDate.getDate() +
                ((1 + 7 - executionDate.getDay()) % 7 || 7),
        );
    }

    executionDate.setHours(6, 0, 0, 0);
    return executionDate.toISOString(); // Format as ISO 8601
};
